import { CustomerFormValues } from '../ui/dialogs/customerFormSchema';

export interface AddressInput {
  city: string;
  country: string;
  postalCode: string;
  stateProvince: string;
  address: string | null;
}

export interface CreateCustomerAccountInput {
  name: string;
  phone: string | null;
  billingAddress: AddressInput | null;
  deliveryAddress: AddressInput | null;
}

export interface AddressViewModel {
  id: string;
  city: string | null;
  address: string | null;
  country: string | null;
  postalCode: string | null;
  stateProvince: string | null;
}

export interface CustomerAccountViewModel {
  id: string;
  name: string;
  phone: string | null;
  billingAddress: AddressViewModel | null;
  deliveryAddress: AddressViewModel | null;
}

const mapAddressToInput = (address: CustomerFormValues['billingAddress']): AddressInput | null => {
  const { streetAddress, city, state, zip, country } = address;

  if (!streetAddress && !city && !state && !zip) {
    return null;
  }

  return {
    city,
    country,
    postalCode: zip,
    stateProvince: state,
    address: streetAddress || null,
  };
};

const mapAddressViewModelToForm = (
  address: AddressViewModel | null | undefined
): CustomerFormValues['billingAddress'] => {
  if (!address) {
    return {
      zip: '',
      city: '',
      state: '',
      country: 'US',
      streetAddress: '',
    };
  }

  return {
    city: address.city ?? '',
    zip: address.postalCode ?? '',
    country: address.country ?? 'US',
    state: address.stateProvince ?? '',
    streetAddress: address.address ?? '',
  };
};

export const mapFormToCreateInput = (values: CustomerFormValues): CreateCustomerAccountInput => {
  const billingAddress = mapAddressToInput(values.billingAddress);
  const deliveryAddress = values.sameAsBilling ? billingAddress : mapAddressToInput(values.deliveryAddress);

  return {
    billingAddress,
    deliveryAddress,
    name: values.name,
    phone: values.phone || null,
  };
};

export const mapViewModelToForm = (vm: CustomerAccountViewModel): Partial<CustomerFormValues> => ({
  name: vm.name,
  phone: vm.phone ?? '',
  billingAddress: mapAddressViewModelToForm(vm.billingAddress),
  deliveryAddress: mapAddressViewModelToForm(vm.deliveryAddress),
});
